import ReactDOM from "react-dom";
import Mobile from './mobile';
import PC from './pc';
import { useState } from "react";
import { getQueryParam } from "./url";

const Index = () => {
  const [isPc, setIsPc] = useState(getQueryParam("mode") === "pc");

  return (
    <div style={{height: '100%', width: '100%'}}>
      {isPc ? <PC setIsPc={setIsPc}/> : <Mobile setIsPc={setIsPc}/>}
    </div>
  )
}

ReactDOM.render(<Index />, document.getElementById("root"));
